import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
/**
 * Quick Button
 */
const Arrow = () => {
  return (
	  <svg width="18" height="15" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.9784 11.0274L12.859 9.97579L13.9784 8.92422C14.2725 8.64798 14.5058 8.32004 14.6649 7.95912C14.824 7.5982 14.906 7.21136 14.906 6.8207C14.906 6.43004 14.824 6.04321 14.6649 5.68229C14.5058 5.32137 14.2725 4.99342 13.9784 4.71719C13.6844 4.44095 13.3353 4.22182 12.9511 4.07232C12.5669 3.92283 12.1551 3.84588 11.7392 3.84588C11.3233 3.84588 10.9116 3.92283 10.5273 4.07232C10.1431 4.22182 9.79404 4.44095 9.49998 4.71719L8.38056 5.76876L7.26115 4.71719L8.38056 3.66561C9.27381 2.84006 10.4781 2.37952 11.7312 2.38431C12.9843 2.38911 14.1846 2.85884 15.0706 3.6912C15.9567 4.52356 16.4567 5.65111 16.4618 6.82823C16.4669 8.00535 15.9767 9.13668 15.0979 9.97579L13.9784 11.0274ZM11.7388 13.1313L10.6194 14.1828C10.1796 14.6027 9.65574 14.9367 9.07791 15.1654C8.50009 15.3941 7.87977 15.5131 7.25274 15.5155C6.62571 15.5179 6.00438 15.4037 5.42459 15.1794C4.8448 14.9551 4.31802 14.6251 3.87464 14.2086C3.43126 13.7921 3.08005 13.2973 2.84128 12.7526C2.6025 12.208 2.48088 11.6243 2.48344 11.0353C2.48599 10.4462 2.61267 9.86351 2.85615 9.32071C3.09964 8.7779 3.45513 8.28575 3.9021 7.87265L5.02152 6.82108L6.14094 7.87265L5.02152 8.92422C4.72746 9.20046 4.4942 9.5284 4.33506 9.88932C4.17591 10.2502 4.094 10.6371 4.094 11.0277C4.094 11.4184 4.17591 11.8052 4.33506 12.1662C4.4942 12.5271 4.72746 12.855 5.02152 13.1313C5.31558 13.4075 5.66468 13.6266 6.04889 13.7761C6.4331 13.9256 6.84489 14.0026 7.26075 14.0026C7.67661 14.0026 8.08841 13.9256 8.47261 13.7761C8.85682 13.6266 9.20592 13.4075 9.49998 13.1313L10.6194 12.0797L11.7388 13.1313ZM11.7388 5.76876L12.859 6.82108L7.26115 12.0789L6.14094 11.0274L11.7388 5.7695V5.76876Z" fill="white"/>
</svg>
  );
};

const PhoneCall = () => {
 return(
 	<svg width="18" height="15" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.74195 14.6412L6.31511 14.9761C7.28169 15.5398 8.38104 15.8358 9.49999 15.8335C10.7526 15.8335 11.9771 15.4621 13.0186 14.7661C14.0601 14.0702 14.8719 13.0811 15.3512 11.9238C15.8306 10.7666 15.956 9.49314 15.7116 8.26459C15.4673 7.03604 14.8641 5.90755 13.9783 5.02182C13.0926 4.13609 11.9641 3.5329 10.7356 3.28852C9.50702 3.04415 8.23359 3.16957 7.07633 3.64893C5.91906 4.12828 4.92993 4.94004 4.23402 5.98155C3.5381 7.02306 3.16666 8.24755 3.16666 9.50016C3.16666 10.637 3.46512 11.7271 4.02482 12.6858L4.35891 13.259L3.84195 15.1598L5.74195 14.6412ZM1.58649 17.4168L2.65682 13.4838C1.95156 12.2748 1.58102 10.8998 1.58332 9.50016C1.58332 5.12779 5.12762 1.5835 9.49999 1.5835C13.8724 1.5835 17.4167 5.12779 17.4167 9.50016C17.4167 13.8725 13.8724 17.4168 9.49999 17.4168C8.10094 17.4191 6.72651 17.0488 5.51791 16.3441L1.58649 17.4168ZM6.64286 5.78566C6.74895 5.77775 6.85582 5.77775 6.96191 5.7825C7.00466 5.78566 7.04741 5.79041 7.09016 5.79516C7.21603 5.80941 7.35457 5.8862 7.40128 5.99229C7.6372 6.52745 7.86678 7.06658 8.08845 7.60729C8.13753 7.72762 8.10824 7.882 8.01482 8.03241C7.95058 8.13412 7.88108 8.23242 7.80661 8.32691C7.71716 8.4417 7.52478 8.65229 7.52478 8.65229C7.52478 8.65229 7.44641 8.7457 7.47649 8.86208C7.48757 8.90641 7.52399 8.97054 7.55724 9.02437L7.60395 9.09958C7.80661 9.43762 8.07895 9.78041 8.41145 10.1034C8.50645 10.1952 8.59907 10.2895 8.69882 10.3773C9.06932 10.7043 9.48891 10.9711 9.94174 11.169L9.9457 11.1706C10.013 11.1999 10.047 11.2157 10.1452 11.2577C10.1943 11.2782 10.2449 11.2965 10.2964 11.3099C10.3496 11.3235 10.4056 11.3209 10.4573 11.3026C10.509 11.2843 10.5542 11.251 10.5869 11.207C11.1601 10.5127 11.2124 10.4676 11.2171 10.4676V10.4692C11.2569 10.432 11.3042 10.4038 11.3559 10.3865C11.4075 10.3692 11.4622 10.3631 11.5164 10.3686C11.5639 10.3718 11.6122 10.3805 11.6565 10.4003C12.0769 10.5927 12.7648 10.8927 12.7648 10.8927L13.2256 11.0993C13.3032 11.1365 13.3736 11.2244 13.376 11.3091C13.3792 11.3622 13.3839 11.4477 13.3657 11.6044C13.3404 11.8095 13.2786 12.0557 13.2169 12.1847C13.1746 12.2728 13.1184 12.3535 13.0506 12.4238C12.9707 12.5077 12.8833 12.584 12.7894 12.6518C12.7569 12.6762 12.7239 12.7 12.6904 12.723C12.5919 12.7855 12.4908 12.8436 12.3872 12.8972C12.1834 13.0055 11.9582 13.0676 11.7277 13.0793C11.5813 13.0872 11.4348 13.0983 11.2876 13.0904C11.2812 13.0904 10.8379 13.0215 10.8379 13.0215C9.71236 12.7254 8.67142 12.1708 7.79791 11.4017C7.61899 11.2442 7.45353 11.0748 7.28412 10.9062C6.57953 10.2055 6.04753 9.4495 5.72453 8.73541C5.55921 8.38493 5.4699 8.00344 5.46249 7.616C5.45923 7.13534 5.61635 6.66732 5.90899 6.286C5.96678 6.21158 6.02141 6.134 6.11561 6.04454C6.21616 5.94954 6.27949 5.89887 6.34836 5.86404C6.43994 5.81815 6.53984 5.79122 6.64207 5.78487L6.64286 5.78566Z" fill="white"/>
</svg>
 )
}
export const QuickBtn = ({ tempItem, idx, boxStyle, onClickEvt, isCert }) => {

  return (
    <div className="_quick_buttons_area">
	{tempItem.button?.value === 'call' ? 
	<button className="_button" style={boxStyle} type='button'>
	<a href='tel:02-3480-1715'>{tempItem.button?.label}
		{tempItem.button.action === 'url' ? <PhoneCall /> : ''}</a>
	 </button>
	:
    isCert? (
      <button className="_button" type='button' style={{ padding: '0px', height: '40px' }} onClick={e => onClickEvt(tempItem.button.value, tempItem.button.action, tempItem.button.label)} aria-label={tempItem.button?.label + ' 새 창 열림'} role='link'>
        <img src={`${process.env.PUBLIC_URL}/images/sa_mark.png`} alt={tempItem.button.label} style={{ height: '40px', padding: '2px', width: '170px', borderRadius: '19px' }}/>
      </button>
    ) : (
      <button className="_button" style={boxStyle} type='button' onClick={e => onClickEvt(tempItem.button.value, tempItem.button.action, tempItem.button.label)} aria-label={tempItem.button?.label + ' 새 창 열림'} role='link'>
        {ReactHtmlParser(`${tempItem.button?.label}`)}
        {tempItem.button.action === 'url' ? <Arrow /> : ''}
      </button>
    )
	}
    </div>
  );
};

const Button = ({ boxStyle, item, viewType, onClickEvt }) => {
  const { items, id, type } = item;
  
  // quick buttons width 때문에 캐로셀 next button 위치가 변경됨
  
  return (
    <>
      <div className="_quick_buttons_div">
        {items.map((tempItem, idx) => {
          return <QuickBtn key={`${tempItem.button?.label}_${idx}`} tempItem={tempItem} idx={idx} boxStyle={boxStyle} onClickEvt={onClickEvt} isCert={tempItem.button?.label.startsWith('소프트웨어')}/>;
        })}
      </div>
    </>
  );
};
Button.propTypes = {
  boxStyle: PropTypes.object,
  item: PropTypes.object,
  viewType: PropTypes.string,
  onClickEvt: PropTypes.func,
};
Button.defaultProps = {
  boxStyle: {},
  item: {},
  viewType: 'advise', // advise, simulator, knowledge
  onClickEvt: null,
};

QuickBtn.propTypes = {
  boxStyle: PropTypes.object,
  idx: PropTypes.number,
  tempItem: PropTypes.object,
  onClickEvt: PropTypes.func,
  isCert: PropTypes.bool,
};
QuickBtn.defaultProps = {
  boxStyle: {},
  idx: 0,
  tempItem: {},
  onClickEvt: null,
  isCert: false,
};

export default Button;
